import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import {
    NegotiationDTORuntype,
    NegotiationPatchDTORuntype,
    NegotiationPostDTORuntype,
    PartOptionRequestSummaryDTORuntype,
} from './negotiationBackendTypes';

export const negotiationEndpoints = {
    // The backend still serves negotiations under /negotiation-v2.
    'GET /negotiation-v2': endpoint({
        description: 'Retrieves all negotiations',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.array(NegotiationDTORuntype),
    }),

    'GET /negotiation-v2/:id': endpoint({
        description: 'Retrieves a negotiation',
        pathParams: z.object({
            id: z.string(),
        }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: NegotiationDTORuntype,
    }),

    'POST /negotiation-v2': endpoint({
        description: 'Creates a negotiation',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: NegotiationPostDTORuntype,
        responseBody: NegotiationDTORuntype,
        // It also creates the request's demand groups and sourcing scenarios, so their bulk queries refetch too.
        invalidates: [
            'GET /negotiation-v2',
            'GET /negotiation-v2/:id',
            'POST /demand-groups/bulk',
            'POST /sourcing-scenarios/bulk',
        ],
    }),

    'PATCH /negotiation-v2/:id': endpoint({
        description: 'Updates a negotiation',
        pathParams: z.object({
            id: z.string(),
        }),
        queryParams: z.undefined(),
        requestBody: NegotiationPatchDTORuntype,
        responseBody: NegotiationDTORuntype,
        invalidates: ['GET /negotiation-v2', 'GET /negotiation-v2/:id'],
    }),

    'DELETE /negotiation-v2/:id': endpoint({
        description: 'Deletes a negotiation',
        pathParams: z.object({
            id: z.string(),
        }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.string(),
        invalidates: ['GET /negotiation-v2', 'GET /negotiation-v2/:id'],
    }),

    'POST /negotiation/line-items/part-options-with-quote-request-line-items': endpoint({
        description: 'Finds part options with quote request line items',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.object({
            solution_configuration_ids: z.array(z.string()),
        }),
        responseBody: z.array(PartOptionRequestSummaryDTORuntype),
    }),
} satisfies Record<string, Endpoint>;

type Endpoint = ReturnType<typeof endpoint>;
